import script from "./ActivityFeed.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActivityFeed.vue?vue&type=script&setup=true&lang=ts"

import "./ActivityFeed.vue?vue&type=style&index=0&id=5769de21&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5769de21"]])

export default __exports__